import { useListProgrammeModulesQuery } from '@/types/vue-apollo-helpers';
import type { ListProgrammeModulesQueryVariables } from '@/types/operations';

export function useProgrammeModules(variables: Ref<ListProgrammeModulesQueryVariables>) {
  const { result, loading, refetch, error } = useListProgrammeModulesQuery(
    variables,
    () => ({
      // Modules are always fetched for a specific programme
      enabled: Boolean(variables.value.programme_id),
      fetchPolicy: 'cache-and-network',
    }),
  );

  return {
    modules: computed(() => result.value?.listProgrammeModules || []),
    loadingModules: loading,
    error,
    refetchModules: refetch,
  };
}
